import CustomerType from '@/contact/constants/CustomerType';
import { UserId } from '@/shared/models/User';
import Vehicle from '@/vehicle/models/Vehicle';
import { VEHICLE_PRESENT_STATUSES } from '../constants/VehicleStatus';
import AbstractDossier from './AbstractDossier';

export interface DossierContactSummary {
  type: CustomerType;
  name: string;
}

export default class DossierSummary extends AbstractDossier {
  mechanicIds: Array<UserId> = [];
  vehicle: Vehicle | null = null;
  contacts: Array<DossierContactSummary> = [];
  order = 0;
  isPreCheckedIn = false;

  isVehiclePresent(): boolean {
    return this.checkedInAt !== null && this.vehicleStatus !== null && VEHICLE_PRESENT_STATUSES.includes(this.vehicleStatus);
  }
}
